<flx-heading align="center" size="small" weight="light">Copy claim number and use in Maven.</flx-heading>
<span id="claimstatus-descriptor">
	This is not a claim or province that is managed by 4-Sure.<br />
	The claim is already opened in Maven but needs to be manually managed.<br /><br />
</span>
<flx-heading color="secondary" size="small" align="center">Maven Claim No: {{ claimMid$ | async }}</flx-heading>
<flx-glow-line color="primary"></flx-glow-line>
<div class="list"><flx-list [ItemList]="listData" id="list-style"></flx-list></div>
<flx-glow-line color="primary"></flx-glow-line>
